import {
  Box,
  CircularProgress,
  FormControlLabel,
  Grid,
  Link,
  MenuItem,
  Radio,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo } from "react";

import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { yupResolver } from "@hookform/resolvers/yup";

import { useGA4React } from "ga-4-react";
import * as yup from "yup";
import {
  CountryList,
  ExemptReasonList,
  NatureOfPersonEntityList,
} from "../../libs/staticData";
import PrimaryButton from "../ui/buttons/primaryButton";
import Input from "../ui/forms/fields/input";
import SearchDropdown from "../ui/forms/fields/searchDropDoown";
import Select from "../ui/forms/fields/select";

import { objectToArray } from "../../libs/helpers";
import SaveProcess from "../dialogs/saveProcess";
import CustomRadioGroup from "../ui/forms/fields/radioGroup";
import { Report } from "../../libs/loggers";

function TaxResidencySelfCerificationDetails({
  extendedForm,
  data,
  submitionData,
  onNext,
  onBack,
  stepSlug,
  openSave,
  onSaveAndExit,
  isRaHelp,
}) {
  const loading = useSelector((state) => state.submition.submition?.loading);
  const userId = useSelector((state) => state.submition.data?.userId);
   const page = window.location.pathname.replace(/^\/|\/$/g, '');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
 const formStepper = useSelector((state) => state.formStepper.value);

  let ga4React = useGA4React();

  const TaxResidencySelfCerificationDetailsFormValidationSchema = (
    data,
    extendedForm,
    isRaHelp
  ) => {
    const validationSchema = yup.object().shape({
      stepSlug: yup.string().required(),
      tinRequired: yup
        .string()
        .test(
          "formIsExtended",
          "Please select if TIN is required.",
          function (val) {
            let isValid = false;

            if (!extendedForm) {
              if (val) isValid = true;
            } else {
              isValid = true;
            }
            return isValid;
          }
        ),

      countryTaxResidence1: yup.string().when(["tinRequired"], {
        is: (tinRequired) => tinRequired === "None",
        then: yup
          .string()
          .required("Please provide your Tax Reference Number OR TIN."),
        otherwise: yup.string(),
      }),

      taxReferenceNumber1: yup
        .string()
        .when(["FATCAconfirm", "tinRequired", "$extendedForm"], {
          is: (FATCAconfirm, tinRequired) =>
            FATCAconfirm === "No" || (!extendedForm && tinRequired === "None"),
          then: yup.string().when("countryTaxResidence1", {
            is: (countryTaxResidence1) => countryTaxResidence1 !== "",
            then: yup
              .string()
              .required("Please provide your Tax Reference Number OR TIN."),
            otherwise: yup.string(),
          }),
          otherwise: yup.string(),
        }),
      countryTaxResidence2: yup.string(),
      taxReferenceNumber2: yup.string(),
      countryTaxResidence3: yup.string(),
      taxReferenceNumber3: yup.string(),

      otherTax: yup
        .string()
        .test("formIsExtended", "Please indicate other tax.", function (val) {
          let isValid = false;

          if (extendedForm) {
            if (val) isValid = true;
          } else {
            isValid = true;
          }
          return isValid;
        }),

      otherTaxCountry1: yup.string().when("otherTax", {
        is: (otherTax) => otherTax === "Yes",
        then: yup.string().required("Please select a country of tax."),
        otherwise: yup.string(),
      }),
      otherTaxCountry2: yup.string(),
      otherTaxCountry3: yup.string(),

      FATCAconfirm: yup
        .string()
        .test(
          "formIsExtended",
          "Are you a U.S. citizen and / or resident?.",
          function (val) {
            let isValid = false;

            if (extendedForm) {
              if (val) isValid = true;
            } else {
              isValid = true;
            }
            return isValid;
          }
        ),

      taxReferenceNumberUS: yup.string().when("FATCAconfirm", {
        is: (FATCAconfirm) => extendedForm && FATCAconfirm === "Yes",
        then: yup
          .string()
          .required("Please provide your U.S. Tax Identifying Number OR TIN."),
        otherwise: yup.string(),
      }),

      boIsExempt: yup
        .string()
        .test("formIsExtended", "Are you exempt from Tax.", function (val) {
          let isValid = false;

          if (extendedForm) {
            if (val) isValid = true;
          } else {
            isValid = true;
          }
          return isValid;
        }),

      boName: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup.string().required("Please enter a name."),
        otherwise: yup.string(),
      }),
      boPersonEntity: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup.string().required("Please select a Person or Entity Type."),
        otherwise: yup.string(),
      }),
      boPersonEntityOther: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boPersonEntity, boIsExempt) =>
          extendedForm && boIsExempt !== "No" && boPersonEntity === "Other",
        then: yup.string().required("Please enter your other."),
        otherwise: yup.string(),
      }),
      boCountryOfRes: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup
          .string()
          .required(
            "Please select a country of residence where DWT exemption is applicable ."
          ),
        otherwise: yup.string(),
      }),
      boCountryForTax: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup
          .string()
          .required(
            "Please enter the country of DWT exemption  where applicable."
          ),
        otherwise: yup.string(),
      }),
      boIdentityNumber: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup.string().required("Please provide a ID/Registration Number."),
        otherwise: yup.string(),
      }),
      boSATaxNr: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup.string().required("Please provide a SA Tax No."),
        otherwise: yup.string(),
      }),
      boPassportNr: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup.string().required("Please provide a Passport Number"),
        otherwise: yup.string(),
      }),
      boCountryIssue: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup
          .string()
          .required("Please tell us where your passport was issued."),
        otherwise: yup.string(),
      }),
      exemptReason: yup.string().when(["boIsExempt", "$extendedForm"], {
        is: (boIsExempt) => extendedForm && boIsExempt !== "No",
        then: yup
          .string()
          .required(
            "Please select a reason for dividend withholding tax exemption."
          ),
        otherwise: yup.string(),
      }),
      incomeTaxNo: yup.string().when("tax_registered", {
        is: (tax_registered) =>
          (isRaHelp && tax_registered === "no") || !isRaHelp,
        then: yup.string().required("Your SARS tax number is required."),
      }),

      reasonForNoSars: yup.string().when(["tax_registered"], {
        is: (tax_registered) => isRaHelp && tax_registered === "no",
        then: yup
          .string()
          .required("Please providerReason for not being registered with SARS"),
        otherwise: yup.string(),
      }),
      ifNo_moreInfo: yup.string().when(["reasonForNoSars", "tax_registered"], {
        is: (reasonForNoSars, tax_registered) =>
          isRaHelp && reasonForNoSars === "Other" && tax_registered === "no",
        then: yup
          .string()
          .required(
            "Please specify the other reason for not having a SARS tax number."
          ),
        otherwise: yup.string(),
      }),
    });

    return validationSchema;
  };

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
    trigger,
    setValue,
    getValues,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      TaxResidencySelfCerificationDetailsFormValidationSchema(
        data,
        extendedForm,
        isRaHelp
      )
    ),
  });

  const taxReferenceNumber1Watch = watch("taxReferenceNumber1");
  const countryTaxResidence1Watch = watch("countryTaxResidence1");
  const countryTaxResidence2Watch = watch("countryTaxResidence2");
  const countryTaxResidence3Watch = watch("countryTaxResidence3");

useEffect(() => {
  setValue('stepSlug', stepSlug, { shouldValidate: true });
}, [stepSlug, setValue]);
  
  useEffect(() => {
    const watchAndSetValue = (watchKey, tinKey) => {
      const watchValue = watch(watchKey);
      if (watchValue && watchValue.length > 0) {
        const selectedCountryObject = CountryList.find(
          (country) => country.label === watchValue
        );
        if (selectedCountryObject) {
          setValue(tinKey, selectedCountryObject.code);
        }
      }
    };

    watchAndSetValue("countryTaxResidence1", "tinRes1");
    watchAndSetValue("countryTaxResidence2", "tinRes2");
    watchAndSetValue("countryTaxResidence3", "tinRes3");
  }, [
    setValue,
    watch,
    countryTaxResidence1Watch,
    countryTaxResidence2Watch,
    countryTaxResidence3Watch,
  ]);

  useEffect(() => {
    if (taxReferenceNumber1Watch) {
      setValue("tax_registered", "yes");
    }
  }, [taxReferenceNumber1Watch, setValue]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      window.scrollTo(0, 0);
    }
  }, []);

  const tinWatch = watch("tinRequired");
  useEffect(() => {
    if (tinWatch) {
      if (tinWatch === "") {
        setValue("tinRequired", "None");
      }

      trigger("tinRequired");
    } else {
      setValue("tinRequired", "None");
    }
  }, [tinWatch, setValue, trigger]);

  useEffect(() => {
    if (submitionData) {
      Object.entries(submitionData).forEach(([key, value]) => {
        setValue(key, value, { validate: true });
      });
    }
  }, [submitionData, setValue]);

  useEffect(() => {
    const eventInfo = {
      action: "view",
      category: "step4_formstep_view",
      description: "viewed a form step in step 4",
      value: {
        currentPage: page,
        stepSlug,
        activeFormStep: formStepper?.step,
      },
    };

   
    Report(eventInfo, userId, submitionId);
  }, []); 

  const NavButtons = (props) => (
    <>
      <Box display="flex" justifyContent={"flex-end"}>
        <PrimaryButton
          disabled={props.isFirstStep}
          onClick={() => onBack()}
          sx={{ mt: 1, mr: 1 }}
        >
          Back
        </PrimaryButton>
        <PrimaryButton
          onClick={() => handleNext()}
          disabled={loading}
          sx={{
            mt: 1,
            mr: 1,
            "&.Mui-disabled": {
              background: "#CC6323",
              color: "#fff",
            },
          }}
        >
          {userId ? "Save & Continue" : "Continue"}{" "}
          {loading && (
            <CircularProgress
              sx={{ ml: 1 }}
              size={isMobile ? 15 : 20}
              color="inherit"
            />
          )}
        </PrimaryButton>
        <PrimaryButton
          variant="outlined"
          onClick={() => handleSaveAndExit(userId)}
          sx={{ mt: 1 }}
        >
          {"Save & Exit"}
        </PrimaryButton>
      </Box>
      {!userId && (
        <Box display="flex" justifyContent={"flex-end"} marginTop={1}>
          <Typography variant="body1">
            {" "}
            Your progress is not being saved. Click{" "}
            <Link
              sx={{ cursor: "pointer" }}
              variant="body1"
              underline="always"
              onClick={() => {
                handleOpenSave();
              }}
            >
              here
            </Link>{" "}
            to save.
          </Typography>
        </Box>
      )}
    </>
  );

  const handleNext = async () => {
    ga4React.event(
      "complete_form_step",
      `${stepSlug}`,
      "investement_submition"
    );
    setValue("completeProcess", false, { shouldValidate: true });
    handleSubmit(onSubmit)();
  };

  const handleSaveAndExit = (userId) => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    onSaveAndExit(newSubmition, userId);
  };

  const handleOpenSave = () => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    openSave(newSubmition);
  };

  const onSubmit = (data) => {
    const newSubmition = { ...submitionData, ...data };
    onNext(newSubmition);
  };

  const subHeading = (sub) => (
    <Typography variant="h6" fontWeight={"bold"} sx={{ mt: 2, mb: 2 }}>
      {sub}
    </Typography>
  );

  return (
    <>
      {extendedForm && (
        <>
          <Typography variant="h5" color="primary" sx={{ mt: 2, mb: 2 }}>
            Dividend Withholding Tax Declaration (DWT)
          </Typography>

          <Select
            name="boIsExempt"
            label="Please select one"
            control={control}
            error={!!errors.boIsExempt}
          >
            <MenuItem
              value={"Yes"}
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {
                "I am (the beneficial owner is) exempt from dividend withholding tax."
              }
            </MenuItem>
            <MenuItem
              value={"No"}
              sx={{
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {
                "I am not (the beneficial owner is not) exempt from dividend withholding tax."
              }
            </MenuItem>
          </Select>

          {watch("boIsExempt") === "Yes" && (
            <Grid container spacing={1}>
              <Grid item xs={12} md={6}>
                <Input
                  label="Full Names and Surnames / Registered Name"
                  helperText={"Should be the name of the Beneficial Owner."}
                  {...register("boName")}
                  error={!!errors?.boName}
                />
                <Input
                  label="Identity/Registration number"
                  {...register("boIdentityNumber")}
                  error={!!errors?.boIdentityNumber}
                />

                <Select
                  name="boPersonEntity"
                  label="Nature of Person / Entity"
                  control={control}
                  error={!!errors?.boPersonEntity}
                >
                  {NatureOfPersonEntityList.map((item) => (
                    <MenuItem key={item.key} value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))}
                  <MenuItem value="Other">Other</MenuItem>
                </Select>

                {watch("boPersonEntity") === "Other" ? (
                  <Input
                    label="Please specify Other"
                    {...register("boPersonEntityOther")}
                    error={!!errors?.boPersonEntityOther}
                  />
                ) : null}
                <Input
                  label="Passport number "
                  {...register("boPassportNr")}
                  error={!!errors?.boPassportNr}
                />

                <SearchDropdown
                  name="boCountryIssue"
                  label="Country of Issue"
                  control={control}
                  error={!!errors?.boCountryIssue}
                  options={CountryList}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <SearchDropdown
                  name="boCountryOfRes"
                  label="Country of residence"
                  control={control}
                  error={!!errors?.boCountryOfRes}
                  options={CountryList}
                  required
                />
                <SearchDropdown
                  name="boCountryForTax"
                  label="Country where Tax Applicable"
                  control={control}
                  error={!!errors?.boCountryForTax}
                  options={CountryList}
                  required
                />
                <Input
                  label="South African Income Tax number"
                  {...register("boSATaxNr")}
                  error={!!errors?.boSATaxNr}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <Select
                  name="exemptReason"
                  label="Reason for Exemption"
                  control={control}
                  error={!!errors?.exemptReason}
                >
                  {ExemptReasonList.map((item) => (
                    <MenuItem key={item.key} value={item.key}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </Grid>
          )}
        </>
      )}

      <Typography variant="h5" color="primary">
        Tax Residency Self-Certification
      </Typography>
      <Grid container spacing={1}>
        {extendedForm && (
          <>
            <Grid item xs={12} md={12}>
              {subHeading(
                "- U.S. Citizenship / U.S. Residence for tax purposes"
              )}
            </Grid>
            <Grid item xs={12}>
              <Select
                name="FATCAconfirm"
                label="Please select one"
                control={control}
                error={!!errors.FATCAconfirm}
              >
                <MenuItem
                  value={"Yes"}
                  sx={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {
                    "I confirm that I am (the investor is) a U.S. citizen and / or resident in the U.S. for tax purposes."
                  }
                </MenuItem>
                <MenuItem
                  value={"No"}
                  sx={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {
                    "I confirm that I am not (the investor is not) a U.S. citizen and / or resident in the U.S. for tax purposes."
                  }
                </MenuItem>
                {/* <MenuItem value={"NotRequired"}>
                      {"I am not required to be registered for tax."}
                    </MenuItem> */}
              </Select>
            </Grid>

            {watch("FATCAconfirm") === "Yes" && (
              <>
                <Grid item xs={12} md={12}>
                  <Typography>
                    The investor’s U.S. federal taxpayer identifying number is:
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Input
                    label="U.S. Tax Identifying Number"
                    {...register("taxReferenceNumberUS")}
                    error={!!errors?.taxReferenceNumberUS}
                  />
                </Grid>
              </>
            )}
          </>
        )}

        <Grid item xs={12} md={12}>
          {subHeading("- Taxpayer / responsible to submit tax return")}
        </Grid>

        <Grid container spacing={1}>
          {" "}
          {isRaHelp && (
            <Grid
              item
              xs={12}
              md={12}
              mb={2}
              display={"flex"}
              alignItems={"center"}
            >
              <Typography variant={"h5"} sx={{ mr: 2 }}>
                Are you a registered taxpayer with SARS?{" "}
              </Typography>
              <CustomRadioGroup
                row
                control={control}
                aria-label="tax_registered"
                name="tax_registered"
                error={!!errors?.tax_registered}
                helperText={errors?.tax_registered?.message}
                xs={{ margin: 1 }}
              >
                <FormControlLabel
                  value={"yes"}
                  control={<Radio />}
                  color="primary"
                  label={"Yes"}
                />
                {!extendedForm && (
                  <FormControlLabel
                    value={"no"}
                    control={<Radio />}
                    color="primary"
                    label={"No"}
                  />
                )}
              </CustomRadioGroup>
            </Grid>
          )}
          {isRaHelp && watch("tax_registered") === "yes" && (
            <Grid
              item
              xs={12}
              md={6}
              mb={2}
              display={"flex"}
              alignItems={"center"}
            >
              <Input
                required
                label="SARS Tax Number"
                {...register("incomeTaxNo")}
                error={!!errors.incomeTaxNo}
                helperText={errors?.incomeTaxNo?.message}
              />
            </Grid>
          )}
          {isRaHelp && watch("tax_registered") === "no" && (
            <Grid item xs={12} md={12}>
              <Select
                name="reasonForNoSars"
                label="Reason for not being registered"
                control={control}
                error={!!errors.reasonForNoSars}
                helperText={errors?.reasonForNoSars?.message}
              >
                <MenuItem
                  value={"ifNo_yearly_taxable"}
                  sx={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {"Yearly taxable income is below tax threshold"}
                </MenuItem>
                <MenuItem
                  value={"ifNo_foreign"}
                  sx={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }}
                >
                  {"Foreign tax resident"}
                </MenuItem>
                <MenuItem value={"Other"}>{"Other"}</MenuItem>
              </Select>
            </Grid>
          )}
          {isRaHelp &&
            watch("reasonForNoSars") === "Other" &&
            watch("tax_registered") === "no" && (
              <Grid item xs={12} md={12}>
                <Input
                  label="Other reason for not being registered "
                  {...register("ifNo_moreInfo")}
                  error={!!errors?.ifNo_moreInfo}
                  helperText={errors?.ifNo_moreInfo?.message}
                />
              </Grid>
            )}
        </Grid>
        {!extendedForm && (
          <Grid item xs={12} md={12}>
            <Select
              required
              name="tinRequired"
              label="Tax Identification Number required / not required?"
              control={control}
              error={!!errors.tinRequired}
              defaultValue={"None"}
            >
              <MenuItem
                value={"None"}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {"I am required to be registered for tax"}
              </MenuItem>
              <MenuItem
                value={"NotRequired"}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {
                  "I am not required to be registered for tax (even though income tax is levied by the jurisdiction)"
                }
              </MenuItem>
              <MenuItem
                value={"NoTin"}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {
                  "No Tax Identification Number (TIN) is issued by the jurisdiction (because income tax is not levied by the jurisdiction)"
                }
              </MenuItem>
              <MenuItem
                value={"NotRequiredToBeReported"}
                sx={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                }}
              >
                {
                  "The Tax Identification Number (TIN) is not required to be reported by such jurisdiction under local law"
                }
              </MenuItem>
            </Select>
          </Grid>
        )}

        {((!extendedForm && watch("tinRequired") === "None") ||
          (watch("FATCAconfirm") &&
            watch("FATCAconfirm") !== "NotRequired")) && (
          <>
            <Grid item xs={12} md={6}>
              <SearchDropdown
                name="countryTaxResidence1"
                label="Country of Tax Residence"
                control={control}
                error={!!errors?.countryTaxResidence1}
                helperText={errors?.countryTaxResidence1?.message}
                options={CountryList}
                required
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Tax Reference Number/Tax Identification Number (TIN)"
                {...register("taxReferenceNumber1")}
                error={!!errors?.taxReferenceNumber1}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchDropdown
                name="countryTaxResidence2"
                label="Country of Tax Residence"
                control={control}
                options={CountryList}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Tax Reference Number/Tax Identification Number (TIN)"
                {...register("taxReferenceNumber2")}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SearchDropdown
                name="countryTaxResidence3"
                label="Country of Tax Residence"
                control={control}
                options={CountryList}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Input
                label="Tax Reference Number/Tax Identification Number (TIN)"
                {...register("taxReferenceNumber3")}
              />
            </Grid>
          </>
        )}

        {extendedForm && (
          <>
            <Grid item xs={12} md={6}>
              <Typography>
                Are you considered a taxpayer, or need to submit a tax return,
                in any other country for which you have not been issued a Tax
                Identification Number (TIN)?
              </Typography>
              <Select
                name="otherTax"
                label="Answer"
                control={control}
                error={!!errors.otherTax}
              >
                <MenuItem value="OtherTaxYes">Yes</MenuItem>
                <MenuItem value="OtherTaxNo">No</MenuItem>
              </Select>
              {watch("otherTax") === "OtherTaxYes" && (
                <>
                  <SearchDropdown
                    name="otherTaxCountry1"
                    label="Country 1"
                    control={control}
                    error={!!errors.otherTaxCountry1}
                    options={CountryList}
                  />{" "}
                  <SearchDropdown
                    name="otherTaxCountry2"
                    label="Country 2"
                    control={control}
                    error={!!errors.otherTaxCountry2}
                    options={CountryList}
                  />{" "}
                  <SearchDropdown
                    name="otherTaxCountry3"
                    label="Country 3"
                    control={control}
                    error={!!errors.otherTaxCountry3}
                    options={CountryList}
                  />{" "}
                </>
              )}
            </Grid>
          </>
        )}

        <Grid item xs={12} md={12}>
          <NavButtons isLastStep={false} isFirstStep={false} index={0} />
        </Grid>
        <Box display={"inlineBlock"}>
          {objectToArray(errors).map((error, index) => (
            <Typography color={"error"} key={index}>
              {error.value.message}
            </Typography>
          ))}
        </Box>
      </Grid>
    </>
  );
}

export default TaxResidencySelfCerificationDetails;
